export const SERIES = "VMKB_060";
export const DIAMETER = "VBGR_060";
export const MATERIAL = "VWST_060";
export const COATING = "VBSCH060";
export const TOLERANCE = "VTOL_060";

export const SHAFT_MACHINING_LEFT = "VBEAL060";
export const SHAFT_MACHINING_MIDDLE = "VBEAM060";
export const SHAFT_MACHINING_RIGHT = "VBEAR060";

export const SHAFT_LENGTH = "VLMAX060";
export const SHAFT_NUMBER_OF_PARTS = "VM990H_060";

export const SHAFT_MIN_LENGTH = "VHLMINT01C_060";
export const SHAFT_MAX_LENGTH = "VHLMAXT01C_060";

export const UNIT = "mm";

export const shaftTolerance = {
  value: "VLMAX_01A_060",
  minmax: {
    ln: "VTOL_LN_060",
    ls: "VTOL_LS_060",
  },
  maxDecimal: 2,
};

export const axialThread = {
  left: {
    size: "VL030_01_060", // editable
    depth: "VL030_02_060", // read only
  },
  right: {
    size: "VR030_01_060", // editable
    depth: "VR030_02_060", // read only
  },
};

export const chamfer = {
  left: {
    angle: "VXL010_01_060",
    width: {
      sf: "VL010_02_060", // Editable width. Used with SF values
      nf: "VL010_02H_060", // Non-editable width. Reference value only for NF angles
      min: "VL010_02T01_060",
      max: "VL010_02T02_060",
    },
  },
  right: {
    angle: "VXR010_01_060",
    width: {
      sf: "VR010_02_060", // Editable width. Used with SF values
      nf: "VR010_02H_060", // Non-editable width. Reference value only for NF angles
      min: "VR010_02T01_060",
      max: "VR010_02T02_060",
    },
  },
};

export const radialThread = {
  size: "VM980_01_060",
  threadSpacing: {
    mode: "VM980_05_060",
    modeRecommended: "1",
    modeIndividual: "2",
    recommended: "VM980_050_060",
    individual: {
      value: "VM980_051_060",
      min: "VM980_051T01_060",
      max: "VM980_051T02C_060",
    },
  },
  aL: {
    value: "VM980_02_1_060",
    min: "VM980_02_1T01_060",
    max: "VM980_02_1T02_060",
  },
  aR: {
    value: "VM980_02_3_060",
    min: "VM980_02_3T01_060",
    max: "VM980_02_3T02_060",
  },
  aLaRMode: "VM980_02_060",
  threadDepth: "VM980T_01_060",
  threadHoleAmount: "VM980_070_INFO_060",
};
